import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import AuthLogo from "../../Components/Auth/AuthLogo";
import AuthCard from "../../Components/Auth/AuthCard";
import AuthContainer from "../../Components/Auth/AuthContainer";
import PublicPageCard from "../../Components/Auth/PublicPageCard";
import { ErrorHandler } from "utils/toast";
import { regeneratePaymentLink } from "slices/thunks";
import { useAppDispatch } from "Components/Hooks/hooks";

const PayDeposit = () => {
  document.title = "EaziQuote - Pay Deposit";

  const { state } = useLocation();
  const paymentId: number | undefined = state?.payment_id;
  const paymentAmount: number | undefined = state?.payment_amount;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  if (!paymentId || !paymentAmount) {
    return <Navigate to="/" replace />;
  }

  const handlePay = async () => {
    try {
      setIsLoading(true);
      const response = await dispatch(
        regeneratePaymentLink({ id: paymentId }),
      )?.unwrap();
      const url = response?.payload?.stripe_payment_link_url;
      if (url) {
        window.location.href = url;
      }
      setIsLoading(false);
    } catch (error) {
      ErrorHandler(error);
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <ParticlesAuth>
        <AuthContainer>
          <Container>
            <Row>
              <Col lg={12}>
                <AuthLogo />
              </Col>
            </Row>

            <Row className="auth-container">
              <Col md={8} lg={6} xl={5}>
                <AuthCard>
                  <PublicPageCard
                    title="Pay Deposit"
                    description="Thanks for accepting the quote. You can pay the deposit now or come back to it anytime using this link."
                    buttonText={`Pay £${Number(paymentAmount).toLocaleString(
                      "en-GB",
                      {
                        minimumFractionDigits: 0,
                      },
                    )}`}
                    onButtonClick={handlePay}
                    isPoweredBy
                    isSkip
                    onSkip={() => {
                      navigate(-1);
                    }}
                    amount={paymentAmount}
                    buttonLoading={isLoading}
                  />
                </AuthCard>
              </Col>
            </Row>
          </Container>
        </AuthContainer>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default PayDeposit;
